export enum PermissionType {
  Base = 'CPM',
  Video = 'VID',
  Tutorial = 'TUT',
  Note = 'NTE',
  Exam = 'EXM',
}

export enum PermissionSource {
  Direct = 'DIRECT'
}

export enum GroupPermissionType {
  Base = 'base',
  Current = 'curr',
}

export enum Location {
  Chatswood = 'Chatswood',
}

export enum QuestionType {
  Calculation = 'CALCULATION',
  Proof = 'PROOF',
  ShortAnswer = 'SHORT ANSWER',
  ExtendedResponse = 'EXTENDED RESPONSE',
  MultipleChoice = 'MULTIPLE CHOICE',
  Graphing = 'GRAPHING',
}

export enum UserType {
  Student = 'STUDENT',
  Staff = 'STAFF',
}

export enum UserGroup {
  Admins = 'Admins',
  Managers = 'Managers',
  Owners = 'Owners',
  Teachers = 'Teachers',
  Students = 'Students',
}

export type StaffUserGroup = UserGroup.Teachers
| UserGroup.Admins
| UserGroup.Managers
| UserGroup.Owners;

export enum EnrolmentType {
  Class = 'CLASS',
  Makeup = 'MAKEUP',
  OneOff = 'ONEOFF',
}

export enum UnenrolmentType {
  Quit = 'QUIT',
  Move = 'MOVE',
}

export enum AttendanceType {
  InPerson = 'IN_PERSON',
  Online = 'ONLINE',
}

export enum LeadType {
  Enrolment = 'ENROLMENT',
  Contact = 'CONTACT',
}

export enum DiscountType {
  Percentage = 'PERCENTAGE',
  Constant = 'CONSTANT',
  OneOff = 'ONEOFF',
}

export enum CourseEnrolmentState {
  Active = 'ACTIVE',
  OnTrial = 'ON_TRIAL',
  Unenrolled = 'UNENROLLED',
}

export enum UserNoteType {
  Student = 'STUDENT',
  Staff = 'STAFF',
  Enrolment = 'ENROLMENT',
  Contact = 'CONTACT',
}

export enum StudentState {
  Lead = 'LEAD',
  Enrolled = 'ENROLLED',
  PendingAttendance = 'PENDING_ATTENDANCE',
  OnTrial = 'ON_TRIAL',
  Active = 'ACTIVE',
  Graduated = 'GRADUATED',
  Archived = 'ARCHIVED',
}

export enum Grade {
  HSC = 'hsc',
  Prelim = 'prelim',
}

// Exam Marking Request States
export enum ExamRequestStatus {
  PendingApproval = 'PENDING_APPROVAL',
  PendingAcceptance = 'PENDING_ACCEPTANCE',
  PendingReassignment = 'PENDING_REASSIGNMENT',
}

export enum ExamAttemptStatus {
  Marked = 'MARKED',
  MarkingInProgress = 'MARKING_IN_PROGRESS',
}

export enum Subject {
  Chemistry = 'chem',
  Physics = 'phys',
  MathsAdv = 'mtad',
  MathsExt1 = 'mtx1',
  MathsExt2 = 'mtx2',
}

export enum AWSCognitoStatus {
  UNCONFIRMED = 'UNCONFIRMED',
  CONFIRMED = 'CONFIRMED',
  UNKNOWN = 'UNKNOWN',
  RESET_REQUIRED = 'RESET_REQUIRED',
  FORCE_CHANGE_PASSWORD = 'FORCE_CHANGE_PASSWORD',
}

export enum UnenrolmentReason {
  NeverAttended = 'never_attended',
  TeacherDissatisfaction = 'teacher_dissatisfaction',
  AdminDissatisfaction = 'admin_dissatisfaction',
  ServiceDissatisfaction = 'service_dissatisfaction',
  TooEasy = 'too_easy',
  TooHard = 'too_hard',
  MismatchingSchedule = 'mismatching_schedule',
  Full = 'full',
  ScheduleConflict = 'schedule_conflict',
  Graduation = 'graduation',
  DroppedCourse = 'dropped_course',
  UnaffordableFees = 'unaffordable_fees',
  AlreadyStudied = 'already_studied',
  GeographicalInconvenience = 'geographical_inconvenience',
  NoImprovement = 'no_improvement',
  FriendPreference = 'friend_preference',
  Accident = 'accident',
  ClassCompletion = 'class_completion',
  Unknown = 'unknown',
}

export enum BillingType {
  Term = 'TERM',
  Extra = 'EXTRA',
}

export enum ContactOption {
  Student = 'STUDENT',
  Parent = 'PARENT',
  Both = 'BOTH',
  None = 'NONE',
}
